export class Policy {
  constructor(props) {
    this.id = props.id;
    this.producto = props.productDescription;
    this.nroPolicy = props.policy;
    this.nroCertificate = props.certificateId;
    this.rol = props.rol;
    this.dateStart = props.startPolicyVigency;
    this.dateEnd = props.endPolicyVigency;
    this.dateVigencia = `${props.startPolicyVigency} ${props.endPolicyVigency && 'al'} ${
      props.endPolicyVigency
    }`;
    this.prima = `${props?.premium?.currencyShortDescription} ${props?.premium?.amount}`;
    this.status = props.status;
    this.idProduct = props.productId.toString();
    this.shortDescription = props.shortDescription;
    this.nbranch = props.branchId.toString();
    this.endoso = props.endoso;

    this.nroPlaca = props?.vehicle?.license;
    this.marca = props?.vehicle?.brand;
    this.modelo = props?.vehicle?.model;
  }
}
